import React from "react";
import { withSearch } from "@elastic/react-search-ui";
import i18n from '../i18n';
import { withTranslation, Trans } from 'react-i18next';
import ResetButton from './ResetButton';

function SelectedFilters(props) {
  const {filters, removeFilter, t } = props
  return (
    
    <ul>
      <li className="filter-hide-btn">        
        <button className="btn gray-btn" onClick={() => props.onShowFilter()}><Trans>Show filters</Trans></button>                                       
      </li>
      <li className="filter-hide-btn">
        <ResetButton></ResetButton>
      </li>
      <li className="filter-title-main">
        <div className="filter-title"><Trans>Selected Filters</Trans></div>                                
      </li>

        {Object.keys(filters).length > 0 ? (
        Object.keys(filters).map(key =>
          {   
            
            return filters[key]?.values?.length > 0 && filters[key]?.values.map(key2 => {
              return (                                    
                <li key={key2}>
                  <button className="btn" onClick={() => removeFilter(filters[key].field,key2)}>
                    {t(filters[key].field)}{(key2!='true'?":"+key2:"")}
                    <div className="close-icon">
                      <img src="/img/svgs/close.svg" className="normal-img" alt="close-icon" />
                      <img src="/img/svgs/close-h.svg" className="hover-img" alt="close-icon" />
                    </div>
                  </button>
                </li>                                    
              ) 
            });                                     
          }
        )) : (
          <li>
            <Trans>No filters available</Trans>
          </li>
        )}   
    </ul>
  );
}

export default withSearch(({ filters, removeFilter }) => ({
  filters,
  removeFilter
}))(withTranslation()(SelectedFilters));